import React, { useEffect, useState } from 'react';
import { isNil, map, orderBy, reverse } from 'lodash';
import translateService from '../../common/translateService';
import BlogHeader from './BlogHeader.jsx';
import NoContent from '../NoContent.jsx';
import BlogPostCard from './BlogPostCard.jsx';

import './BlogHomePage.scss';

const BlogCategoryLanding = ({
    bloglistcontent,
    banneranddescription,
    title,
}) => {
    const [header, setHeader] = useState({
        banner: {},
        description: {},
        youtube: {},
    });
    const [blogPosts, setBlogPosts] = useState([]);

    useEffect(() => {
        const bannerAndDescription = JSON.parse(banneranddescription);
        if (
            !isNil(bannerAndDescription) &&
            !isNil(bannerAndDescription.attributes)
        ) {
            const x = bannerAndDescription.attributes;
            setHeader({
                banner: x.banner.data.attributes,
                description: x.description,
                youtube: x.youtube,
            });
        }

        const bp = JSON.parse(bloglistcontent);
        setBlogPosts(
            reverse(orderBy(bp, (x) => x.mainCreativeWork.datePublished))
        );
    }, []);

    return (
        <>
            <BlogHeader
                banner={header.banner}
                description={header.description}
                title={translateService.get(`blog.${title}`)}
            />
            {blogPosts.length > 0 ? (
                <div className='blog-posts-category-container'>
                    {map(blogPosts, (b, idx) => (
                        <BlogPostCard key={idx} blogPost={b} />
                    ))}
                </div>
            ) : (
                <NoContent />
            )}
        </>
    );
};

export default BlogCategoryLanding;
